import axios from '@/api/axios'

export default {
    roles: {
        getRoles: () => axios.get('/base/api/roles').then((res) => res.data),
    },
}
